export type TimelineSegment = "序幕" | "铺陈" | "转折" | "高潮" | "尾声";

export interface Chapter {
  id: string;
  index: number;
  title: string;
  segment: TimelineSegment;
  duration: number;
  timeline: string;
  tags: string[];
  cover: string;
  excerpt: string;
  paragraphs: string[];
}

export interface FilmPick {
  id: string;
  title: string;
  year: number;
  region: string;
  genre: string;
  rating: string;
  reason: string;
  cover: string;
}

export interface SpecialArticle {
  slug: string;
  group: "影评" | "幕后" | "角色";
  title: string;
  subtitle: string;
  cover: string;
  readTime: string;
  date: string;
  paragraphs: string[];
}

export const filmInfo = {
  title: "色戒无删减版",
  originalTitle: "Lust, Caution",
  year: "2007",
  region: "中国 / 美国",
  director: "李安（示例资料）",
  stars: "梁朝伟 / 汤唯 / 王力宏（示例资料）",
  runtime: "约 158 分钟",
  language: "普通话 / 粤语 / 上海话",
  genre: "剧情 / 谍战 / 年代",
  score: "8.4",
  intro:
    "故事发生在战火未熄的年代，一群热血青年以戏剧为伪装，把真实的人生搬上危险的舞台。她以一枚戒指为信物走进对方的日常，也在一次次试探中逐渐分不清表演与真心的边界。",
};

export const timelineSegments: TimelineSegment[] = ["序幕", "铺陈", "转折", "高潮", "尾声"];

export const chapters: Chapter[] = [
  {
    id: "chapter-01",
    index: 1,
    title: "牌桌上的暗流",
    segment: "序幕",
    duration: 12,
    timeline: "00:00 - 00:12",
    tags: ["牌局", "试探", "群像", "悬念"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20still%20life%20of%20a%20mahjong%20table%20with%20ivory%20tiles%2C%20deep%20wine%20red%20velvet%20and%20antique%20gold%20tones%2C%20low%20key%20lighting%2C%20film%20noir%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20elegant%20abstract%20composition%2C%20no%20text&width=800&height=500&seq=sj-ch-01&orientation=landscape",
    excerpt: "一张牌桌，四个人，无数种心思。开场用一场看似闲适的牌局，把人物关系与危险气息同时铺开。",
    paragraphs: [
      "影片从一间挂着厚窗帘的客厅开始。麻将牌碰撞的声音很清脆，屋里的人却都说着与牌面无关的话。谁都懂规则，谁都在等对方先露出破绽。",
      "女主角坐在牌桌一角，穿着合身的旗袍，笑得恰到好处。她观察每一个人出牌的停顿，也留意门口进出的脚步声，仿佛这间屋子的每一寸空气都属于她。",
      "这场戏的妙处在于节奏：台词轻、镜头慢，却让人隐约觉得危险正从桌布下面慢慢升上来。",
    ],
  },
  {
    id: "chapter-02",
    index: 2,
    title: "雨夜里的接头",
    segment: "序幕",
    duration: 9,
    timeline: "00:12 - 00:21",
    tags: ["雨夜", "接头", "暗号", "紧张"],
    cover:
      "https://readdy.ai/api/search-image?query=rainy%20night%20street%20with%20wet%20cobblestone%20reflecting%20amber%20gas%20lamp%20light%2C%20deep%20burgundy%20shadows%2C%20old%20shanghai%20alley%20atmosphere%2C%20cinematic%20compositing%2C%20moody%20low%20key%20photography%2C%20abstract%20and%20atmospheric%2C%20no%20text&width=800&height=500&seq=sj-ch-02&orientation=landscape",
    excerpt: "雨声盖住交谈，伞沿挡住视线。一次短暂的会面，决定了后面所有人的命运走向。",
    paragraphs: [
      "雨下得不算大，却足够把整条街洗成一面模糊的镜子。她撑着伞站在屋檐下，鞋跟轻轻敲着石阶，等一个不该在此刻出现的人。",
      "对方递来一只纸包，没有多余的话。她把它收进手袋，顺手整理了一下被风吹乱的发丝，像是在整理自己的表情。",
      "镜头没有给纸包特写，观众的注意力反而被留在了两个人之间那半步的距离上，那是最危险、也最暧昧的位置。",
    ],
  },
  {
    id: "chapter-03",
    index: 3,
    title: "一场精心编排的相遇",
    segment: "铺陈",
    duration: 14,
    timeline: "00:21 - 00:35",
    tags: ["戏剧", "伪装", "青年", "排练"],
    cover:
      "https://readdy.ai/api/search-image?query=empty%20vintage%20theatre%20stage%20with%20single%20warm%20spotlight%20and%20crimson%20curtain%2C%20dust%20particles%20in%20golden%20light%2C%20cinematic%20wide%20shot%2C%20melancholic%20film%20noir%20mood%2C%20rich%20burgundy%20and%20brass%20palette%2C%20no%20text&width=800&height=500&seq=sj-ch-03&orientation=landscape",
    excerpt: "一群年轻人把舞台当成战场，也把人生当成剧本。相遇不再是偶遇，而是反复排练后的必然。",
    paragraphs: [
      "空荡荡的剧场里，几个人围坐读本。他们讨论台词的重音，也讨论一个人应该如何自然地走进另一人的生活。",
      "她念台词时声音很稳，眼睛里却有一点不属于角色的犹豫。同伴提醒她，太投入会让人忘记退场的路。",
      "这一段看似是准备，其实是全片最重要的一次提问：当一个人演得太久，她还认得自己原本的样子吗？",
    ],
  },
  {
    id: "chapter-04",
    index: 4,
    title: "珠宝店与镜子",
    segment: "铺陈",
    duration: 13,
    timeline: "00:35 - 00:48",
    tags: ["珠宝", "戒指", "暧昧", "细节"],
    cover:
      "https://readdy.ai/api/search-image?query=antique%20jewelry%20shop%20interior%20with%20velvet%20display%20cases%20and%20a%20single%20gold%20ring%20under%20soft%20warm%20light%2C%20mirrored%20surfaces%2C%20deep%20wine%20red%20curtains%2C%20elegant%20cinematic%20still%20life%2C%20shallow%20focus%2C%20no%20text&width=800&height=500&seq=sj-ch-04&orientation=landscape",
    excerpt: "试戴一枚戒指只需要几秒钟，可这几秒钟里，两个人的关系被悄悄改写。",
    paragraphs: [
      "珠宝店里光线柔和，玻璃柜擦得很亮。她低头看自己的手，指尖因为紧张而微微发凉，那点凉意被对方一句话轻轻掩过去。",
      "镜子里出现了两个人的影子，一前一后。谁也不看谁，但谁都在意镜子里的那个画面。",
      "戒指是信物，也是计量单位：它衡量着一份感情到底有多重，也提醒着这场关系最初的目的。",
    ],
  },
  {
    id: "chapter-05",
    index: 5,
    title: "越界的试探",
    segment: "转折",
    duration: 16,
    timeline: "00:48 - 01:04",
    tags: ["对峙", "情感", "失控", "室内戏"],
    cover:
      "https://readdy.ai/api/search-image?query=dark%20elegant%20apartment%20interior%20with%20heavy%20wine%20red%20drapes%2C%20single%20lamp%20casting%20amber%20light%2C%20empty%20armchair%20and%20gramophone%2C%20cinematic%20chiaroscuro%20lighting%2C%20melancholic%20period%20drama%20mood%2C%20no%20text&width=800&height=500&seq=sj-ch-05&orientation=landscape",
    excerpt: "原本被设计好的距离突然失效，两人都在试探对方的底线，也在试探自己的。",
    paragraphs: [
      "房间不大，家具摆得很满，反而让人无处可退。她把外套挂在门边，动作慢得像在拖延什么。",
      "他终于问出那个一直绕着走的问题，语气平静，手指关节却绷得很紧。她没有立刻回答，只是把窗户推开一条缝。",
      "这一段没有大声争吵，所有冲突都压在呼吸和停顿里。越界的不是身体，而是原本互相承认的那套规则。",
    ],
  },
  {
    id: "chapter-06",
    index: 6,
    title: "密信与暗号",
    segment: "转折",
    duration: 11,
    timeline: "01:04 - 01:15",
    tags: ["密信", "暗号", "情报", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=handwritten%20letter%20and%20fountain%20pen%20on%20a%20dark%20wooden%20desk%2C%20warm%20amber%20desk%20lamp%20glow%2C%20candlelight%20and%20cigarette%20smoke%2C%20deep%20brown%20and%20gold%20palette%2C%20moody%20cinematic%20still%20life%2C%20no%20text&width=800&height=500&seq=sj-ch-06&orientation=landscape",
    excerpt: "一封信在几个人手里传递，每转一次手，内容就多一层解读，也多一分危险。",
    paragraphs: [
      "夜里，台灯只照亮桌面一小块地方。她写下几行字，又反复划掉，纸被磨得有些起毛。",
      "约定好的暗号藏在一句普通的问候里，听起来毫无破绽。门外传来脚步声时，她把信折成很小的方块。",
      "观众比她更早知道这封信会被谁看到，所以每一秒都像悬在半空。",
    ],
  },
  {
    id: "chapter-07",
    index: 7,
    title: "封锁线下的奔跑",
    segment: "高潮",
    duration: 18,
    timeline: "01:15 - 01:33",
    tags: ["封锁", "追逐", "群像", "高压"],
    cover:
      "https://readdy.ai/api/search-image?query=night%20alley%20blocked%20by%20wooden%20barricades%20and%20paper%20lanterns%2C%20silhouettes%20and%20long%20shadows%2C%20deep%20crimson%20and%20gold%20light%20spill%2C%20tense%20cinematic%20atmosphere%2C%20grainy%20film%20noir%20look%2C%20no%20text&width=800&height=500&seq=sj-ch-07&orientation=landscape",
    excerpt: "街口被封住，灯一盏盏灭下去。所有铺垫在这一段收紧成一根拉满的弦。",
    paragraphs: [
      "警戒线拉起来的时候，街上还有人提着刚买的菜。有人回头，有人加快脚步，只有她必须保持平常的速度。",
      "镜头跟着她穿过弄堂，经过晾着的衣服、堆叠的木箱和半掩的门。每一个转角都可能通向出口，也可能通向结束。",
      "这一段几乎是全片节奏最快的地方，剪辑把等待、追赶与猜测压在同一段时间里，让人来不及喘气。",
    ],
  },
  {
    id: "chapter-08",
    index: 8,
    title: "最后一颗钻石",
    segment: "高潮",
    duration: 15,
    timeline: "01:33 - 01:48",
    tags: ["抉择", "珠宝", "情感", "特写"],
    cover:
      "https://readdy.ai/api/search-image?query=single%20diamond%20ring%20resting%20on%20black%20velvet%20under%20a%20narrow%20beam%20of%20golden%20light%2C%20deep%20burgundy%20background%2C%20dramatic%20macro%20cinematic%20still%20life%2C%20elegant%20and%20restrained%2C%20no%20text&width=800&height=500&seq=sj-ch-08&orientation=landscape",
    excerpt: "灯光落在戒指上，也落在她的脸上。一个极小的动作，改变了所有人接下来的命运。",
    paragraphs: [
      "店里安静得能听见钟表走动。他把戒指推到她面前，说这是早就订好的，只等她来看。",
      "她的手指停在半空，眼神从戒指移到他的脸上。那一刻她想的不是任务，也不是退路，而是一个再普通不过的念头：原来他真的记得。",
      "镜头停留得比观众能承受的时间更长。正是这几秒钟的犹豫，让后面的所有事情都变得无法挽回。",
    ],
  },
  {
    id: "chapter-09",
    index: 9,
    title: "三分钟的决定",
    segment: "高潮",
    duration: 8,
    timeline: "01:48 - 01:56",
    tags: ["抉择", "沉默", "眼神", "转折"],
    cover:
      "https://readdy.ai/api/search-image?query=two%20empty%20chairs%20facing%20each%20other%20in%20a%20dim%20room%2C%20warm%20amber%20light%20through%20half%20open%20blinds%2C%20long%20shadows%20on%20wooden%20floor%2C%20minimal%20cinematic%20composition%2C%20melancholic%20burgundy%20and%20gold%20tones%2C%20no%20text&width=800&height=500&seq=sj-ch-09&orientation=landscape",
    excerpt: "没有台词的三分钟。她只说了一个字，却像把整部电影重新翻了一页。",
    paragraphs: [
      "走廊很长，脚步声从远处传来。她站在门口，手扶着门框，像是在等一个可以推翻决定的理由。",
      "他抬头看她，没有催促。空气里有一种近乎温柔的安静，让这个决定变得更难。",
      "她最终开口，声音很轻。镜头没有切到听者的反应，而是留在她的侧脸上，让观众自己去判断那到底是背叛，还是唯一一次真正的选择。",
    ],
  },
  {
    id: "chapter-10",
    index: 10,
    title: "空荡的公寓",
    segment: "尾声",
    duration: 12,
    timeline: "01:56 - 02:08",
    tags: ["余韵", "空镜", "回忆", "克制"],
    cover:
      "https://readdy.ai/api/search-image?query=empty%20vintage%20apartment%20room%20with%20unmade%20bed%20and%20sheer%20curtains%20moving%20in%20the%20wind%2C%20dust%20in%20soft%20afternoon%20light%2C%20faded%20wine%20red%20and%20warm%20beige%20tones%2C%20melancholic%20cinematic%20interior%2C%20no%20text&width=800&height=500&seq=sj-ch-10&orientation=landscape",
    excerpt: "人走了，屋子还留着痕迹。尾声用大量空镜，把没说完的话交给光线和家具。",
    paragraphs: [
      "窗帘被风吹起一角，桌上的杯子还留着半圈水痕。她不在这个房间里了，可房间到处都像她的样子。",
      "镜头慢慢推过衣柜、梳妆台和床边的一双拖鞋，没有配乐，只有楼下隐约的车声。",
      "这段处理得很克制，没有解释谁对谁错，只允许观众在空荡的空间里把情绪补齐。",
    ],
  },
  {
    id: "chapter-11",
    index: 11,
    title: "旧唱片还在转",
    segment: "尾声",
    duration: 10,
    timeline: "02:08 - 02:18",
    tags: ["音乐", "怀旧", "余韵", "细节"],
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20gramophone%20with%20spinning%20vinyl%20record%20in%20a%20dim%20room%2C%20warm%20gold%20glow%20on%20brass%20horn%2C%20deep%20burgundy%20shadows%2C%20nostalgic%20cinematic%20still%20life%2C%20soft%20film%20grain%2C%20no%20text&width=800&height=500&seq=sj-ch-11&orientation=landscape",
    excerpt: "唱片转到了最后一圈，声音开始失真。有人停下来听完，也有人从此不再回头。",
    paragraphs: [
      "唱片机的针走到尽头，发出细小的沙沙声。房间里的人没有起身，任由那点噪音继续响着。",
      "一首歌在这样的时刻变得很残忍，因为它提醒你，美好的部分确实发生过，而且已经结束。",
      "导演把镜头留在旋转的唱片上，让时间像被卡住的圆圈一样，重复又无法回头。",
    ],
  },
  {
    id: "chapter-12",
    index: 12,
    title: "尘埃落定之后",
    segment: "尾声",
    duration: 9,
    timeline: "02:18 - 02:27",
    tags: ["结局", "留白", "回望", "余味"],
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20street%20corner%20at%20dusk%20with%20old%20streetlamp%20and%20a%20single%20chair%20outside%20a%20closed%20shop%2C%20deep%20amber%20and%20wine%20red%20dusk%20sky%2C%20lonely%20cinematic%20wide%20shot%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=sj-ch-12&orientation=landscape",
    excerpt: "故事结束了，问题却刚刚开始。最后一章留给观众的是两个座位和一片空街。",
    paragraphs: [
      "天快黑的时候，街角的路灯先亮起来。店铺已经关门，门口留着一把没人收走的椅子。",
      "影片没有给出解释，也没有安排谁回来。它只是把镜头往后拉了一点，让整条街都进入画面。",
      "看完之后你可能会重新想起开场那张牌桌：原来从第一分钟起，输赢就已经写好，只是没有人愿意承认。",
    ],
  },
];